import { useDispatch, useSelector } from "react-redux";
import { X } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

import { fetchDataPayment, removeGiftCardCode } from "../actions/checkoutStore";

export const GiftCards = ({ allowRemoval }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const summary = useSelector((state) => state.checkoutStore.summary);

  const removeGiftCard = (id) => {
    if (!allowRemoval) return;
    dispatch(removeGiftCardCode(id));
    dispatch(fetchDataPayment());
  };

  return (
    summary.gift_cards?.length > 0 &&
    (allowRemoval ? (
      <div className="separatedContent" id="summary_gift_cards">
        <span className="span-font-14">{t("summary.gift-cards")}</span>
        <div>
          {summary.gift_cards.map((gift_card, index) => (
            <div
              key={index}
              className="d-flex justify-content-between align-items-center mb-2"
            >
              <span className="span-font-14 me-2">
                - {gift_card.amount}{" "}
                {gift_card.code_last_4_digits &&
                  `( •••• ${gift_card.code_last_4_digits})`}
              </span>
              <a href="#" onClick={() => removeGiftCard(gift_card.id)}>
                <X className="fas" size={24} weight="light" />
              </a>
            </div>
          ))}
        </div>
      </div>
    ) : (
      <div className="row g-0 mb-2" id="summary_gift_cards">
        <b className="col-sm-3 span-font-14">{t("summary.gift-cards")}</b>
        <div className="col-sm-9 d-inline-flex align-items-center">
          <div className="pr-2">
            {summary.gift_cards.map((gift_card, index) => (
              <div key={index} className="span-font-14 mr-2">
                - {gift_card.amount}{" "}
                {gift_card.code_last_4_digits &&
                  `( •••• ${gift_card.code_last_4_digits})`}
              </div>
            ))}
          </div>
        </div>
      </div>
    ))
  );
};
